<p-dialog
    appDialogoPadrao="pi pi-info-circle"
    descricao="Por que a biometria foi marcada como anômala."
    [(visible)]="showDialog"
    (onShow)="OnDialogShow()"
    (onHide)="hideDialog()"
    [dismissableMask]="true"
    [breakpoints]="{ '960px': '80vw', '640px': '95vw' }"
    [style]="{ width: '28rem' }"
    header="Motivo da anomalia"
>
    <div class="content">
        <label class="block text-sm font-medium mb-2">Escolha o motivo da anomalia</label>

        <p-select class="w-full" [style]="{ width: '100%' }" [options]="opcoesItems" optionLabel="label" optionValue="value" [(ngModel)]="selecionado" appendTo="body" placeholder="Selecione..."></p-select>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 w-full">
            <p-button label="Cancelar" severity="secondary" (onClick)="cancelar()"></p-button>
            <p-button label="Confirmar" icon="pi pi-check" (onClick)="confirmar()"></p-button>
        </div>
    </ng-template>
</p-dialog>
